import { render, staticRenderFns } from "./superQuery.vue?vue&type=template&id=04842dd8&scoped=true"
import script from "./superQuery.vue?vue&type=script&lang=js"
export * from "./superQuery.vue?vue&type=script&lang=js"
import style0 from "./superQuery.vue?vue&type=style&index=0&id=04842dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04842dd8",
  null
  
)

export default component.exports